import { TextTestID } from "@/constants/TestID";
import EventAttendeesList from "@/ui/components/schedule/EventCardAttendeesList";
import { Text } from "@/ui/core";
import { BaseCard, Box, StandardCardWidth, VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface UpcomingEventCardProps extends ViewWithTestID {
  attendees: BaseUserAvatarProps[];
  onPress?: () => void;
  title: string;
  when: string;
}

const MaxHeight = 140;

const UpcomingEventCard = ({
  attendees,
  onPress,
  testID,
  title,
  when,
}: UpcomingEventCardProps) => {
  return (
    <BaseCard
      maxHeight={MaxHeight}
      maxWidth={StandardCardWidth}
      onPress={onPress}
      testID={joinTestIDs(testID, TextTestID.Card)}
    >
      <VStack gap={12}>
        <VStack gap={2}>
          <Box height={42}>
            <Text
              numberOfLines={2}
              testID={joinTestIDs(testID, TextTestID.Title)}
              variant="bodyMedium"
            >
              {title}
            </Text>
          </Box>
          <Text
            color={ColorToken.NeutralSecondary}
            testID={joinTestIDs(testID, TextTestID.Date)}
            variant="caption"
          >
            {when}
          </Text>
        </VStack>
        <EventAttendeesList attendees={attendees} />
      </VStack>
    </BaseCard>
  );
};

export type { UpcomingEventCardProps };
export { MaxHeight };
export default UpcomingEventCard;
